<template>
  <div>
    <div v-if="$isDataLoaded(transcript)">
      <div class="scoring-board">
        <div class=" group-score">
          <span class="caption">课堂总得分：{{ userTotalScore | fixed }}</span>
          <progress class="progress is-link" :value="userTotalScore" :max="totalScore"></progress>
        </div>
        <div v-if="choices.length" class="group-score">
          <span class="caption">单项选择题：{{ userScore.choice | fixed }}</span>
          <progress class="progress is-link" :value="userScore.choice" :max="score.choice"></progress>
        </div>
        <div v-if="multiChoices.length" class="group-score">
          <span class="caption">多项选择题：{{ userScore.multiChoice | fixed }}</span>
          <progress class="progress is-link" :value="userScore.multiChoice"
                    :max="score.multiChoice"></progress>
        </div>
        <div v-if="choiceBlanks.length" class="group-score">
          <span class="caption">选择填空题：{{ userScore.choiceBlank | fixed }}</span>
          <progress class="progress is-link" :value="userScore.choiceBlank"
                    :max="score.choiceBlank"></progress>
        </div>
        <div v-if="trueFalses.length" class="group-score">
          <span class="caption">判断正误题：{{ userScore.trueFalse | fixed }}</span>
          <progress class="progress is-link" :value="userScore.trueFalse"
                    :max="score.trueFalse"></progress>
        </div>
        <div v-if="programmings.length" class="group-score">
          <span class="caption">程序设计题：{{ userScore.programming | fixed }}</span>
          <progress class="progress is-link" :value="userScore.programming"
                    :max="score.programming"></progress>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import _ from 'lodash'

export default {
  props: ['transcript', 'problems'],
  data () {
    return {
      takeId: '',
      choices: 0,
      multiChoices: 0,
      trueFalses: 0,
      choiceBlanks: 0,
      blanks: 0,
      programmings: 0,
      score: {
        choice: 0,
        blank: 0,
        multiChoice: 0,
        choiceBlank: 0,
        trueFalse: 0,
        programming: 0
      },
      userScore: {
        choice: 0,
        blank: 0,
        multiChoice: 0,
        choiceBlank: 0,
        trueFalse: 0,
        programming: 0
      },
      ui: {
        color: {
          choice: '',
          blank: '',
          multiChoice: '',
          choiceBlank: '',
          trueFalse: '',
          programming: ''
        }
      }
    }
  },
  computed: {
    userTotalScore () {
      if (this.$isDataLoaded(this.transcript, this.problems)) {
        let userScore = 0
        this.userScore.choice = this.userScore.multiChoice = this.userScore.choiceBlank = this.userScore.trueFalse = this.userScore.blank = this.userScore.programming = 0
        for (const problemId in this.transcript) {
          if (_.isNumber(this.transcript[problemId].score) && this.transcript[problemId].score >= 0) {
            const problem = _.find(this.problems, { '_id': parseInt(problemId) })
            if (problem) {
              problem.userScore = this.transcript[problemId]
              switch (problem.type) {
                case 'choice':
                  this.userScore.choice += this.transcript[problemId].score
                  break
                case 'multi-choice':
                  this.userScore.multiChoice += this.transcript[problemId].score
                  break
                case 'choice-blank':
                  this.userScore.choiceBlank += this.transcript[problemId].score
                  break
                case 'true-false':
                  this.userScore.trueFalse += this.transcript[problemId].score
                  break
                case 'blank':
                  this.userScore.blank += this.transcript[problemId].score
                  break
                case 'programming':
                  this.userScore.programming += this.transcript[problemId].score
                  break
              }
            }
            userScore += this.transcript[problemId].score
          }
        }
        return userScore
      }
      return ''
    },
    totalScore () {
      if (this.$isDataLoaded(this.problems)) {
        this.score.choice = this.score.multiChoice = this.score.choiceBlank = this.score.trueFalse = this.score.blank = this.score.programming = 0
        this.choices = []
        this.blanks = []
        this.multiChoices = []
        this.choiceBlanks = []
        this.trueFalses = []
        this.programmings = []
        return this.problems.reduce((sum, problem) => {
          switch (problem.type) {
            case 'choice':
              this.choices.push(problem)
              this.score.choice += parseInt(problem.score)
              break
            case 'multi-choice':
              this.multiChoices.push(problem)
              this.score.multiChoice += parseInt(problem.score)
              break
            case 'choice-blank':
              this.choiceBlanks.push(problem)
              this.score.choiceBlank += parseInt(problem.score)
              break
            case 'true-false':
              this.trueFalses.push(problem)
              this.score.trueFalse += parseInt(problem.score)
              break
            case 'blank':
              this.blanks.push(problem)
              this.score.blank += parseInt(problem.score)
              break
            case 'programming':
              this.programmings.push(problem)
              this.score.programming += parseInt(problem.score)
              break
          }
          return sum + parseInt(problem.score)
        }, 0)
      }
      return ''
    }
  },
  methods: {
    getScore (score) {
      if (!score) return 0
      if (score.status === 300) return '未提交'
      if (score.status === 400) return '未评分'
      return score.score
    }
  },
  components: {}
}
</script>
<style scoped>
.image svg {
  display: block;
  height: auto;
  width: 100%;
}

.caption {
  width: 200px;
}

.scale {
  font-size: 12px;
  color: #333333;
  padding: 0;
  margin: 0;
  display: flex;
}

.scale .line {
  display: block;
  text-align: right;
  width: 10%;
  padding-left: 10px;
  flex-shrink: 0;
  flex-grow: 0;
}

.scale .line:first-child {
  width: calc(60% + 1.5em);
}

.scale .line:last-child {
  width: calc(10% - 0.5em);
  position: absolute;
  right: 0;
  font-size: 2em;
  margin-top: -10px;
}

.scale .line:last-child:before {
  width: 0;
}

.scale .line:before {
  content: '';
  height: calc(100% - 2.5em);
  width: 1px;
  background: #333333;
  position: absolute;
  margin-top: 2em;
  opacity: .2;
  z-index: 0;
  margin-left: .5em;
}

.scoring-board {
  position: relative;
}

.group-score {
  margin: 15px 5px 15px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.columns.vertical-center {
  align-items: center;
}
</style>
